export const getListUf = () => [
  {
    uf: 'Acre',
    label: 'AC',
  },
  {
    uf: 'Alagoas',
    label: 'AL',
  },
  {
    uf: 'Amapá',
    label: 'AP',
  },
  {
    uf: 'Amazonas',
    label: 'AM',
  },
  {
    uf: 'Bahia',
    label: 'BA',
  },
  {
    uf: 'Ceará',
    label: 'CE',
  },
  {
    uf: 'Distrito Federal',
    label: 'DF',
  },
  {
    uf: 'Espírito Santo',
    label: 'ES',
  },
  {
    uf: 'Goiás',
    label: 'GO',
  },
  {
    uf: 'Maranhão',
    label: 'MA',
  },
  {
    uf: 'Mato Grosso',
    label: 'MT',
  },
  {
    uf: 'Mato Grosso do Sul',
    label: 'MS',
  },
  {
    uf: 'Minas Gerais',
    label: 'MG',
  },
  {
    uf: 'Pará',
    label: 'PA',
  },
  {
    uf: 'Paraíba',
    label: 'PB',
  },
  {
    uf: 'Paraná',
    label: 'PR',
  },
  {
    uf: 'Pernambuco',
    label: 'PE',
  },
  {
    uf: 'Piauí',
    label: 'PI',
  },
  {
    uf: 'Rio de Janeiro',
    label: 'RJ',
  },
  {
    uf: 'Rio Grande do Norte',
    label: 'RN',
  },
  {
    uf: 'Rio Grande do Sul',
    label: 'RS',
  },
  {
    uf: 'Rondônia',
    label: 'RO',
  },
  {
    uf: 'Roraima',
    label: 'RR',
  },
  {
    uf: 'Santa Catarina',
    label: 'SC',
  },
  {
    uf: 'São Paulo',
    label: 'SP',
  },
  {
    uf: 'Sergipe',
    label: 'SE',
  },
  {
    uf: 'Tocantins',
    label: 'TO',
  },
];
